 var init = false;
var swiper;
function swiperCard() {
  if (window.innerWidth <= 768) {
    if (!init) {
      init = true;
const swiperThumbs = new Swiper('.swiperThumbs', {
  spaceBetween: 10,
  slidesPerView: 4,
  freeMode: true,
  watchSlidesProgress: true,
  direction: 'horizontal',
  loop: false,
    breakpoints: {
    760: {
      direction: 'vertical',
    },
  },
});
      
const swiper = new Swiper('.swiperBox', {
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  thumbs: {
    swiper: swiperThumbs,
  },
});
    }
  } else if (init) {
    swiper.destroy();
    init = false;
  }
}
swiperCard();
window.addEventListener("resize", swiperCard);

document.addEventListener("DOMContentLoaded", () => {
  const cartSwiper = new Swiper('.wrapIt2 ', { 
// Optional parameters
  loop: true,
  spaceBetween: 10,
  slidesPerView: 2,
});

desktopSlide();
window.addEventListener("resize", desktopSlide);

  function desktopSlide() {

    if (window.innerWidth <= 768) {
      return;
    }
    
      let slides = document.querySelectorAll(".swiperBox .swiper-slide");
      let i = 0;
      slides.forEach(function(el) {
        if(i >3) {
          el.classList.add("hidden");
        }
        i++;
      });
    
      if(document.querySelector(".swiperBoxMore")) {
          document.querySelector(".swiperBoxMore").addEventListener("click", function (e) {
        if(this.classList.contains('open')) {
          this.classList.remove("open");
          this.innerHTML = 'Mehr anzeigen';
          let i = 0;
          slides.forEach(function(el) {
            if(i >3) {
              el.classList.add("hidden");
            }
            i++;
          });
        } else {
          this.classList.add("open");
          this.innerHTML = 'Weniger anzeigen';
          let i = 0;
          slides.forEach(function(el) {
            if(i >3) {
              el.classList.remove("hidden");
            }
            i++;
          });
        }
      });
      }
  }



  // setTimeout(() => {
    const cta = document.querySelector("product-info .product-form__buttons");
    const stickyCta = document.querySelector(".stickyCta");
    
    if (cta) {
      window.onscroll = function() {stickCta()};

  
     function stickCta() {
        let ctaPos = cta.getBoundingClientRect().top;
        if (ctaPos <=0) {
           stickyCta.classList.add("show");
        } else {
           stickyCta.classList.remove("show");
        }
     }
    }
  // }, "1000");


});


const productIconsBar = new Swiper('.boxesMobile', {
  slidesPerView: 4,
  spaceBetween: 15,
  loop: false,
});


const swiperRecommand = new Swiper('.swiperRecommand', {
  slidesPerView: 1,
  loop: false,
  
  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },
});

const swiperArtikelBox = new Swiper('.swiperArtikelBox', {
  slidesPerView: "auto",
  loop: false,
  grid: {
    rows: 2
  },
  spaceBetween: 30,
  breakpoints: {
    760: {
  centeredSlides: false,
    slidesPerView: 2,
      grid: {
        rows: 2
      },
    },
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});

const buttons = document.querySelectorAll(".product-form__buttons")
for (const button of buttons) {
  button.addEventListener('click', function(event) {
    button.classList.add("clicked");
    setTimeout(() => {
       button.classList.remove("clicked");
    }, 5000);
  })
}



const showRecom = document.querySelectorAll(".show.recommand");
for (const elem of showRecom) {
	elem.addEventListener ("click", (eve) => {
		elem.nextElementSibling.style.display = 'grid';
        let scrollHeightEle = elem.nextElementSibling.scrollHeight;
        elem.closest('.rs_recommand-wrapper').style.height = (scrollHeightEle+30)+'px';
	})
}

const closeRecom = document.querySelectorAll(".close.recommand");
for (const elem of closeRecom) {
	elem.addEventListener ("click", (eve) => {
      console.log(elem.parentElement);
		elem.parentElement.style.display = 'none';
        elem.closest('.rs_recommand-wrapper').style.height = 'auto';
	})
}




function ctaRecommandClick (event, index) {
  
  if(event.closest(".popUpBox")) {
    parent = event.closest(".popUpBox").className;
  } else {
    parent = event.closest(".rs_recommand-wrapper .box").className;
  }

  const recommandInfos = document.querySelectorAll('.' + parent + ' .option');
  const recommands = [];
  const selected = [];
  var obj = {};
  
    
  recommandInfos.forEach((recommandInfo) => {
    recommands.push(recommandInfo.querySelectorAll('.' + parent + ' .option input:checked'));
  })
  let postData = [];
  recommands.forEach((recommand, index) => { 
    index = index+1;

recommand.forEach((options) => {
    console.log(options.value);

    // Produktinformationen für das aktuelle Produkt
    let productData = {
        quantity: 1,  // Menge des Produkts
        id: options.value  // ID des Produkts
    };

    // Produktinformationen zum postData-Array hinzufügen
    postData.push(productData);
});

    if (postData.length > 1) {
        jQuery.post('/cart/add', { items: postData })
        .done(function() {
          // POST-Request erfolgreich abgeschlossen
          const currentUrl = window.location.href;
          const newUrl = new URL(currentUrl);
          newUrl.searchParams.set('openMiniCart', 'true');
          window.location.href = newUrl.toString();
        })
        .fail(function() {
          // Fehler beim POST-Request
          console.error('Fehler beim Hinzufügen zum Warenkorb.');
        });

    } 

      
    //   jQuery.get( "https://milanea.de/"+recommand[0].dataset.url+".json", function( data ) {
    //   const varianten = data.product.variants;
    //   varianten.filter(function (variant) {
    //     if(recommand[1]?.value !== undefined) {
    //       if (variant.title == recommand[0].value + ' / ' + recommand[1]?.value) {
    //         console.log(variant.id);
    //             jQuery.post('/cart/add', {
    //               items: [
    //               {
    //                 quantity: 1,
    //                 id: variant.id
    //               }
    //             ]
    //           })
    //       }
    //     } else {
    //       if (variant.title == recommand[0].value) {
    //             jQuery.post('/cart/add', {
    //               items: [
    //               {
    //                 quantity: 1,
    //                 id: variant.id
    //               }
    //             ]
    //           })
    //       }
    //     }

    //   })
    // })


  })


}

// js/custom-element/ui/tabs-nav.js
  var TabsNav = class extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll("button[aria-controls]"));
      this.scrollerElement = this.querySelector(".tabs-nav__scroller");
      this.buttons.forEach((button) => button.addEventListener("click", () => this.selectButton(button)));
      this.addEventListener("shopify:block:select", (event) => this.selectButton(event.target, !event.detail.load));
      this.positionElement = document.createElement("span");
      this.positionElement.classList.add("tabs-nav__position");
      this.buttons[0].parentElement.insertAdjacentElement("afterend", this.positionElement);
      window.addEventListener("resize", this._onWindowResized.bind(this));
      this._adjustNavigationPosition();
      if (this.hasArrows) {
        this._handleArrows();
      }
    }
    get hasArrows() {
      return this.hasAttribute("arrows");
    }
    get selectedTabIndex() {
      return this.buttons.findIndex((button) => button.getAttribute("aria-expanded") === "true");
    }
    get selectedButton() {
      return this.buttons.find((button) => button.getAttribute("aria-expanded") === "true");
    }
    selectButton(button, animate = true) {
      if (!this.buttons.includes(button) || this.selectedButton === button) {
        return;
      }
      const from = document.querySelector('.'+this.selectedButton.getAttribute("aria-controls")), to = document.querySelector('.'+button.getAttribute("aria-controls"));
      console.log(from);
      if (animate) {
        this._transitionContent(from, to);
      } else {
        from.hidden = true;
        to.hidden = false;
      }
      this.selectedButton.setAttribute("aria-expanded", "false");
      button.setAttribute("aria-expanded", "true");
      triggerEvent(this, "tabs-nav:changed", { button });
      this._adjustNavigationPosition();
    }
    addButton(button) {
      button.addEventListener("click", () => this.selectButton(button));
      button.setAttribute("aria-expanded", "false");
      this.buttons[this.buttons.length - 1].insertAdjacentElement("afterend", button);
      this.buttons.push(button);
      this._adjustNavigationPosition(false);
    }
    _transitionContent(from, to) {
      from.animate({
        opacity: [1, 0]
      }, {
        duration: 250,
        easing: "ease"
      }).onfinish = () => {
        from.hidden = true;
        to.hidden = false;
        to.animate({
          opacity: [0, 1]
        }, {
          duration: 250,
          easing: "ease"
        });
      };
    }
    _onWindowResized() {
      this._adjustNavigationPosition();
    }
    _adjustNavigationPosition(shouldAnimate = true) {
      const scale = this.selectedButton.clientWidth / this.positionElement.parentElement.clientWidth, translate = this.selectedButton.offsetLeft / this.positionElement.parentElement.clientWidth / scale, windowHalfWidth = this.scrollerElement.clientWidth / 2;
      this.scrollerElement.scrollTo({
        behavior: shouldAnimate ? "smooth" : "auto",
        left: this.selectedButton.offsetLeft - windowHalfWidth + this.selectedButton.clientWidth / 2
      });
      if (!shouldAnimate) {
        this.positionElement.style.transition = "none";
      }
      this.positionElement.style.setProperty("--scale", scale);
      this.positionElement.style.setProperty("--translate", `${translate * 100}%`);
      this.positionElement.clientWidth;
      requestAnimationFrame(() => {
        this.positionElement.classList.add("is-initialized");
        this.positionElement.style.transition = null;
      });
    }
    _handleArrows() {
      const arrowsContainer = this.querySelector(".tabs-nav__arrows");
      arrowsContainer.firstElementChild.addEventListener("click", () => {
        this.selectButton(this.buttons[Math.max(this.selectedTabIndex - 1, 0)]);
      });
      arrowsContainer.lastElementChild.addEventListener("click", () => {
        this.selectButton(this.buttons[Math.min(this.selectedTabIndex + 1, this.buttons.length - 1)]);
      });
    }
  };
  window.customElements.define("tabs-nav", TabsNav);
